import { render } from "./AppDropdownMenu.vue?vue&type=template&id=b1f00484&ts=true"
import script from "./AppDropdownMenu.vue?vue&type=script&lang=ts"
export * from "./AppDropdownMenu.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/wVusKqw4/1/kenniss/platform/educator/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__